/**
 * Safely show a browser notification
 * Handles both regular Notification API and ServiceWorker notifications
 */
export const showBrowserNotification = async (title, options = {}) => {
  // Check if notifications are supported
  if (!("Notification" in window)) {
    console.log("Browser notifications not supported");
    return null;
  }

  // Check permission
  if (Notification.permission !== "granted") {
    console.log("Notification permission not granted");
    return null;
  }

  const defaultOptions = {
    icon: "/logo192.png",
    badge: "/logo192.png",
    tag: `task-hero-${Date.now()}`,
    requireInteraction: false,
    silent: false,
    ...options
  };

  try {
    // Try using ServiceWorker first (required in some contexts)
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      const registration = await navigator.serviceWorker.ready;
      await registration.showNotification(title, defaultOptions);
      return null; // ServiceWorker notifications don't return a Notification object
    }
    
    // Fallback to regular Notification API
    const notification = new Notification(title, defaultOptions);
    
    // Auto-close after 10 seconds
    if (options.autoClose !== false) {
      setTimeout(() => notification.close(), 10000);
    }
    
    // Handle click
    notification.onclick = () => {
      window.focus();
      notification.close();
      if (options.onClick) {
        options.onClick();
      }
    };
    
    return notification;
  } catch (error) {
    console.error("Failed to show notification:", error);
    
    // If regular Notification fails, try ServiceWorker as fallback
    try {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.ready;
        await registration.showNotification(title, defaultOptions);
      }
    } catch (swError) {
      console.error("ServiceWorker notification also failed:", swError);
    }
    
    return null;
  }
};

export default showBrowserNotification;
